import { render, staticRenderFns } from "./WealList.vue?vue&type=template&id=6b75fac8&"
import script from "./WealList.vue?vue&type=script&lang=ts&"
export * from "./WealList.vue?vue&type=script&lang=ts&"
import style0 from "./WealList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports